import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import Logo from "../ui/Logo";
import Footer from "./Footer";

interface PublicLayoutProps {
    children?: React.ReactNode;
}

export default function PublicLayout({ children }: PublicLayoutProps) {
    const { isAuthenticated } = useAuth();
    const token = localStorage.getItem("token");
    const loggedIn = isAuthenticated || !!token;

    return (
        <div className="flex flex-col min-h-screen bg-slate-50 text-slate-800 font-sans antialiased">
            {/* Navigation Header */}
            <header className="sticky top-0 z-50 bg-white/75 backdrop-blur-md border-b border-slate-200/50">
                <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
                    <Logo />

                    <nav className="flex items-center gap-4">
                        {loggedIn ? (
                            <Link
                                to="/dashboard"
                                className="px-4 py-2 text-xs font-bold text-white bg-gradient-to-r from-violet-600 to-fuchsia-600 rounded-xl shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
                            >
                                Go to Dashboard
                            </Link>
                        ) : (
                            <>
                                <Link
                                    to="/login"
                                    className="px-4 py-2 text-xs font-bold text-slate-600 hover:text-violet-600 transition-colors"
                                >
                                    Log In
                                </Link>
                                <Link
                                    to="/signup"
                                    className="px-4 py-2 text-xs font-bold text-white bg-violet-600 hover:bg-violet-700 rounded-xl shadow-xs transition-colors"
                                >
                                    Sign Up
                                </Link>
                            </>
                        )}
                    </nav>
                </div>
            </header>

            {/* Page Content */}
            <main className="flex-1 w-full bg-linear-to-b from-purple-50/30 to-white">
                {children}
            </main>

            {/* Premium Footer */}
            <Footer />
        </div>
    );
}
